// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"9086a37e","845":"45f6cbc1"}[chunkId] + ".chunk.js";
};